import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

import { DEFAULT_WIDTH } from "../map";

export const AddStationWrapperStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "add-station-wrapper",
})`
  display: grid;
  grid-template-columns: 1fr 40px 40px 1fr;
  align-items: center;
  margin-top: 15px;
  border-radius: 6px;
  padding-inline-start: 10px;
  padding-inline-end: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
  border: 1px solid ${greyMui._200};

  .add-station__add-new-station-form {
    display: grid;
    grid-template-columns: ${DEFAULT_WIDTH}px 1fr;
    grid-column: 1 / -1;
    gap: 10px;
    border: 1px solid ${greyMui._200};
    padding: 8px 8px 8px 10px;
    border-radius: 4px;
    margin: 10px -11px 0 -11px;
  }

  .add-station__add-new-station-form-static-map-wrapper {
    grid-column: 1 / 2;
  }

  .add-station__add-new-station-form-controls {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    grid-column: 2 / 3;
  }
  .add-station__form-actions {
    margin-top: 20px;
    grid-column: 1 / -1;
    justify-self: end;
    display: flex;
    gap: 10px;
  }
`;
